/**
 * @file: useEcho.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { serviceFactory } from '@euler/services/factory';
import { useMemo } from 'react';

export const useEcho = () => {
  useMemo(() => {
    serviceFactory.supportService
      .echo()
      .then(() => {
        __DEV__ && console.log('echo received');
      })
      .catch(() => null);
  }, []);
};
